import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_doc_approval_request_queue_RowClass} from '../../../dbschema';

export class ClaimDocApprovalRequestContainerModel extends BaseContainerModel {
  bl_aat_claim_doc_approval_request_queue: bl_aat_claim_doc_approval_request_queue_RowClass = new bl_aat_claim_doc_approval_request_queue_RowClass();
}
